import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import brideImg from '../../images/zsofi_head.webp'
import engagementImg from '../../images/us/engagement.jpg'
import coupleImg3 from '../../images/couple/shape.png'
import groomImg from '../../images/peti_head.webp'
import { useLanguage } from '../../contexts/LanguageContext';
 
class CoupleSectionInner extends Component {

    render() {
        const { t } = this.props;
        return(
            <section className={`couple-section section-padding ${this.props.cClass}`} id="couple">
                <style>
                    {`
                        .couple-section .couple-area {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .couple-section .text-grid {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            padding-top: 0 !important;
                            padding-bottom: 0 !important;
                            text-align: center !important;
                        }
                        .couple-section .text-grid .couple-img {
                            margin-left: auto !important;
                            margin-right: auto !important;
                        }
                        .couple-section .middle-couple-pic {
                            margin-left: 60px !important;
                            margin-right: 60px !important;
                        }
                        @media (max-width: 991px) {
                            .couple-section .middle-couple-pic {
                                display: none !important;
                            }
                        }
                    `}
                </style>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col col-xs-12">
                            <div className="couple-area clearfix">
                                <div className="text-grid groom">
                                    <div className="couple-img">
                                        <img src={groomImg} alt=""/>
                                    </div>
                                    <h3>{t('couple.groomName')}</h3>
                                    <p>{t('couple.groomDescription')}</p>
                                </div>
                                <div className="middle-couple-pic">
                                    <img src={engagementImg} alt=""/>
                                    <div className="frame-img"><img src={coupleImg3} alt=""/></div>
                                </div>
                                <div className="text-grid bride">
                                    <div className="couple-img">
                                        <img src={brideImg} alt=""/>
                                    </div>
                                    <h3>{t('couple.brideName')}</h3>
                                    <p>{t('couple.brideDescription')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
        );
    }
}

const CoupleSection = (props) => {
    const { t } = useLanguage();
    return <CoupleSectionInner {...props} t={t} />;
};
 
export default CoupleSection;